import { matchPath, useLocation, useParams } from 'react-router';

import {
  ROUTE_ASSIST_INSIGHTS_INSIGHT_CARD_VIEW,
  ROUTE_SOLVE_INSIGHTS_INSIGHT_CARD_VIEW,
} from 'src/components/app/routes/routeDefinitions';
import { useGetChartByIdQuery } from 'src/services/insight-cards';

export default function useInsightCardViewInfo() {
  const { pathname } = useLocation();

  const insightCardViewPathMatch =
    matchPath(ROUTE_SOLVE_INSIGHTS_INSIGHT_CARD_VIEW, pathname) ||
    matchPath(ROUTE_ASSIST_INSIGHTS_INSIGHT_CARD_VIEW, pathname);

  const { cardId } = useParams();
  const { data: chart } = useGetChartByIdQuery(cardId || '', {
    skip: !insightCardViewPathMatch || !cardId,
  });

  return {
    channels: chart?.channels || [],
    isApiOnly: chart?.channels?.length === 1 && chart?.channels[0] === 'api',
    isInsightCardView: !!insightCardViewPathMatch,
    isMultipleChannels: (chart?.channels?.length || 0) > 1,
    isSlackOnly:
      chart?.channels?.length === 1 && chart?.channels[0] === 'slack',
    isVoiceOnly:
      chart?.channels?.length === 1 && chart?.channels[0] === 'voice',
  } as const;
}
